import { useUnit } from 'effector-react';
import { Card, Col, Row } from 'antd';
import MapBlock from '../../components/MapBlock/MapBlock';
import { $isTablet, $tabletBarHidden } from '../../models/authModel';
import { $mapLoaded } from '../../models/mapModel';
import TabletLeftBar from '../../components/TabletLeftBar/TabletLeftBar';
import LeftBar from '../../components/LeftBar/LeftBar';
import TopBar from '../../components/TopBar/TopBar';
import SideModal from '../../components/SideModal/SideModal';
import PresetsSideModal from '../../components/PresetsSideModal/PresetsSideModal';
import style from './MainMapPublic.module.css';

function MainMapPublic() {
  const isTablet = useUnit($isTablet);
  const tabletBarHidden = useUnit($tabletBarHidden);
  const mapLoaded = useUnit($mapLoaded);
  if (isTablet) {
    return (
      <Row gutter={[5, 0]} style={{ padding: '5px 0px', height: '100%' }}>
        <Col
          style={{
            width: tabletBarHidden ? 'calc(100% - 86px)' : 'calc(100% - 385px)',
            transition: '0.5s all',
          }}
        >
          <Card className="map_card" bodyStyle={{ height: '100%' }}>
            <MapBlock />
          </Card>
        </Col>
      </Row>
    );
  }
  return (
    <Row gutter={[20, 0]} style={{ height: '100%' }}>
      <Col style={{ width: '100%' }}>
        <div className={style.test}>
          <TopBar />
          <Card className="map_card" bodyStyle={{ height: '100%' }}>
            <MapBlock />
          </Card>
        </div>
        {/* <Space id="top_bar" className={style.top_bar} direction="vertical"> */}
        {/* </Space> */}
      </Col>
      <SideModal />
      <PresetsSideModal />
    </Row>
  );
}

export default MainMapPublic;
